module.exports = __webpack_public_path__ + "img/Verrerie.5990b3b.jpg";